import type { EditorSaveEditOrReviewRequestPortfolioSavingModeEnum } from "@eu.mdotm.api/sphere";
import type { Instrument } from "$root/functional-areas/instruments-editor/const";
import type { Map } from "immutable";

function countInstrumentInComposition(
	validInstruments: Map<string, Instrument>,
	savingMode: EditorSaveEditOrReviewRequestPortfolioSavingModeEnum,
): number {
	return validInstruments.reduce((sum, instrument) => {
		if (savingMode === "NEST_PORTFOLIOS") {
			return sum + 1;
		}

		if (instrument.proxyOverwriteType === "PORTFOLIO_MIXED") {
			const instrumentsInInvestment = instrument.nofInstruments ?? 0;
			const instrumentsExcluded = instrument.nOfInstrumentExcluded ?? 0;
			return instrumentsInInvestment - instrumentsExcluded + sum;
		}

		return sum + 1;
	}, 0);
}

function isInstrumentCountValid(
	nOfInstrumentsInComposition: number,
	opt: {
		minInstrumentsInComposition: number;
		maxInstrumentsInComposition: number;
	},
): boolean {
	return (
		nOfInstrumentsInComposition >= opt.minInstrumentsInComposition &&
		nOfInstrumentsInComposition <= opt.maxInstrumentsInComposition
	);
}

export { countInstrumentInComposition, isInstrumentCountValid };
